<template>
  <v-app class="login-page">
    <v-content>
      <v-container class="fill-height align-start" fluid>
        <div class="language-switcher">
          <TheLanguageSwitcher />
        </div>
        <v-row>
          <v-col cols="12" md="6">
            <v-card>
              <div class="login-box">
                <div class="logo-box d-flex justify-center">
                  <img class="logo" src="../assets/logo-main2.png" />
                </div>
                <!-- <v-alert
                                        v-if="errorCredential"
                                        class="alert alert-danger align-center"
                                        color="#fceec4"
                                        prominent
                                        icon="mdi-alert-outline"
                                >
                                    <div class="title">{{ $t('amai') }}</div>
                                    <div>{{ $t('error_credential') }}</div>
                                </v-alert>
                                <v-alert
                                        v-if="errorCredentialAccess"
                                        class="alert alert-danger align-center"
                                        color="#fceec4"
                                        prominent
                                        icon="mdi-alert-outline"
                                >
                                    <div class="title">{{ $t('amai') }}</div>
                                    <div>{{ $t('error_credential_no_access') }}</div>
                                </v-alert> -->

                <v-alert
                  v-if="accessError"
                  class="alert alert-danger align-center"
                  color="#fceec4"
                  prominent
                  icon="mdi-alert-outline"
                >
                  <div class="title">{{ $t("amai") }}</div>
                  <div>{{ accessErrorMessage }}</div>
                </v-alert>

                <v-alert v-if="successAlert" outlined type="success" text>
                  <div>{{ successAlertMessage }}</div>
                </v-alert>

                <v-form @submit="handleSubmit">
                  <div v-if="!isForgotPassword">
                    <div class="label">{{ $t("username") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="email"
                      name="email"
                      v-model="user.email"
                    ></v-text-field>
                    <div v-if="errorEmailRequired" class="alert alert-danger">
                      {{ $t("username_is_required") }}
                    </div>

                    <!-- <div v-if="errorEmailFormat" class="alert alert-danger">{{ $t('email_is_invalid') }}</div> -->
                    <div class="label">{{ $t("password") }}</div>
                    <v-text-field
                      outlined
                      class="passw-input"
                      height="65"
                      background-color="#f6f9fb"
                      :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="showPass ? 'text' : 'password'"
                      @click:append="showPass = !showPass"
                      v-model="user.password"
                      id="password"
                      name="password"
                    ></v-text-field>
                    <div
                      v-if="errorPasswordRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("password_is_required") }}
                    </div>
                    <div v-if="errorPasswordLength" class="alert alert-danger">
                      {{
                        $t("password_length_characters", {
                          passLength: passwordLength,
                        })
                      }}
                    </div>
                  </div>

                  <div v-if="isForgotPassword">
                    <div class="label">{{ $t("username") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="username"
                      name="username"
                      v-model="forgotPasswordUsername"
                    ></v-text-field>
                    <div
                      v-if="errorUsernameRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("username_is_required") }}
                    </div>

                    <div class="label">{{ $t("email") }}</div>
                    <v-text-field
                      outlined
                      height="65"
                      background-color="#f6f9fb"
                      id="email"
                      name="email"
                      v-model="forgotPasswordEmail"
                    ></v-text-field>
                    <div
                      v-if="errorForgotEmailRequired"
                      class="alert alert-danger"
                    >
                      {{ $t("email_is_required") }}
                    </div>
                  </div>

                  <div class="forgot-password">
                    <span @click="handleClickForgotPassword">
                      {{ isForgotPassword ? $t("back") : $t("forgotPassword") }}
                    </span>
                  </div>

                  <v-btn
                    type="submit"
                    height="65"
                    block
                    dark
                    color="#08a657"
                    class="login-btn"
                  >
                    {{ isForgotPassword ? $t("getPassword") : $t("login") }}
                    <v-avatar size="40" color="rgba(0, 0, 0, 0.15)"
                      ><v-icon medium>mdi-arrow-right</v-icon></v-avatar
                    >
                  </v-btn>
                  <label v-if="!isForgotPassword" class="checkbox">
                    {{ $t("remember_me") }}
                    <input
                      type="checkbox"
                      checked="checked"
                      v-model="user.remember"
                      id="remember"
                      name="remember"
                    />
                    <span class="checkmark"></span>
                  </label>
                </v-form>
                <v-btn
                  v-if="!isForgotPassword"
                  type="button"
                  height="65"
                  block
                  dark
                  color="#08a657"
                  class="login-btn"
                  @click="openMicrosoftLogin"
                >
                  {{ $t("login") }} Microsoft
                  <v-icon right> mdi-microsoft </v-icon>
                </v-btn>
              </div>
              <v-divider></v-divider>
              <div class="copyright-box d-flex align-center">
                <div>
                  &copy;
                  {{
                    $t("copyright", {
                      currentYear: this.$store.state.currentYear,
                    })
                  }}
                  | <b>{{ $t("pricvacy_statment") }}</b> {{ $t("in") }}
                  <b>{{ $t("disclaimer") }}</b>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="isShowModalLoginMs" max-width="600px" persistent>
        <v-card>
          <v-card-title class="headline lighten-2" primary-title>
            {{ $t("login") }} Microsoft
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <div class="pt-10 pb-10 mb-10">
              <v-text-field
                v-model="microsoftEmail"
                :label="$t('user.email')"
                outlined
                :error="isErrorMicrosoftEmail"
                :error-messages="errorMicrosoftEmail"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn right text color="primary" @click="closeModalLoginMs">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              right
              text
              color="primary"
              class="ml-5"
              @click="skipAndLoginMS"
            >
              {{ $t("skip") }}
            </v-btn>
            <v-btn
              right
              text
              color="primary"
              class="ml-5"
              @click="checkUserEmail"
            >
              {{ $t("login") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-snackbar
        v-model="snackbar"
        :timeout="0"
        top
        multi-line
        color="white"
        content-class="snackbar-content"
      >
        <div class="snackbar-root">
          <div class="snackbar-text">
            {{ snackbarText }}
          </div>

          <div class="snackbar-actions">
            <v-btn text class="snackbar-btn" @click="logoutMicrosoft">
              LOGOUT MICROSOFT
            </v-btn>

            <v-btn text class="snackbar-btn" @click="closeMsError">
              CLOSE
            </v-btn>
          </div>
        </div>
      </v-snackbar>
    </v-content>
  </v-app>
</template>

<script>
import TheLanguageSwitcher from "@/components/TheLanguageSwitcher";
import config from "../config";
import Axios from "axios";
import { i18n } from "@/plugins/i18n";
import router from "@/router";

import { mapMutations } from "vuex";
import { Trans } from "@/plugins/Translation";
import { logout as logOut } from "@/services/logout.js";
import {
  popMsAuthError,
  preflightOpenId,
  setMsAuthError,
  resetMsalInteractionState,
} from "@/utils/msAuth";
import { saveAuthSession } from "@/utils/authSession";

const qs = require("querystring");

export default {
  components: {
    TheLanguageSwitcher,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        remember: false,
      },
      passwordFieldType: "password",
      errorEmailRequired: false,
      errorEmailFormat: false,
      errorPasswordRequired: false,
      errorPasswordLength: false,
      passwordLength: 50,
      // errorCredential: false,
      // errorCredentialAccess: false,
      showPass: false,
      checkbox: true,

      isShowModalLoginMs: false,
      microsoftEmail: "",
      isErrorMicrosoftEmail: false,
      errorMicrosoftEmail: "",

      accessError: false,
      accessErrorMessage: "",

      successAlert: false,
      successAlertMessage: "",

      isForgotPassword: false,
      forgotPasswordUsername: "",
      errorUsernameRequired: false,
      forgotPasswordEmail: "",
      errorForgotEmailRequired: false,
      msLoginInProgress: false,
      msAuthFailed: false,
      snackbar: false,
      snackbarText: "",
    };
  },

  mounted() {
    const msg = popMsAuthError();
    if (msg) {
      this.snackbarText = msg;
      this.snackbar = true;
      resetMsalInteractionState();
    }
  },

  created() {
    //this.setDefaultMsalConfig();

    const details = sessionStorage.getItem("ms_auth_error_details");
    if (details && details !== "undefined" && details !== "null") {
      this.snackbarText = details;
      this.snackbar = true;

      this.$nextTick(() => {
        sessionStorage.removeItem("ms_auth_error_details");
        sessionStorage.removeItem("ms_auth_error_time");
      });
    }
  },

  methods: {
    ...mapMutations(["SET_LOGIN_USER", "SET_USER_ORGANIZATIONS"]),

    handleClickForgotPassword() {
      this.accessError = false;
      this.accessErrorMessage = "";
      this.successAlert = false;
      this.successAlertMessage = "";
      this.isForgotPassword = !this.isForgotPassword;
      this.forgotPasswordUsername = "";
      this.forgotPasswordEmail = "";

      this.errorEmailRequired = false;
      this.errorEmailFormat = false;
      this.errorPasswordRequired = false;
      this.errorPasswordLength = false;
      this.errorUsernameRequired = false;
      this.errorForgotEmailRequired = false;
    },

    logout() {
      logOut();
    },

    closeMsError() {
      this.snackbar = false;
      this.snackbarText = "";
      sessionStorage.removeItem("ms_auth_error");
      sessionStorage.removeItem("ms_auth_error_ts");
    },

    skipAndLoginMS() {
      sessionStorage.removeItem("msal_runtime_config"); // будет default common
      sessionStorage.setItem("start_msal_login", "1");
      sessionStorage.removeItem("msal_login_hint");
      window.location.reload();
    },

    async checkUserEmail() {
      const email = (this.microsoftEmail || "").trim();

      if (!email) {
        this.isErrorMicrosoftEmail = true;
        this.errorMicrosoftEmail = this.$i18n.t("organization.emptyEmailError");
        return;
      }

      // сброс ошибок ДО запроса
      this.isErrorMicrosoftEmail = false;
      this.errorMicrosoftEmail = "";

      // (опционально) блокировка двойного клика
      if (this.msLoginInProgress) return;
      this.msLoginInProgress = true;

      try {
        const resp = await Axios.get(
          config.apiBaseUrl +
            `api/organization/azure-properties?email=${encodeURIComponent(
              email
            )}`
        );

        const tenantId = resp?.data?.tenantId;
        const applicationId = resp?.data?.applicationId;

        if (!tenantId || !applicationId) {
          this.isErrorMicrosoftEmail = true;
          this.errorMicrosoftEmail =
            "Azure properties response is missing tenantId/applicationId";
          this.msLoginInProgress = false;
          return;
        }

        const authority = `https://login.microsoftonline.com/${tenantId}`;

        try {
          await preflightOpenId(authority);
        } catch (e) {
          const msg = String(
            e?.message || e || "Microsoft configuration error"
          );

          // 1) показываем пользователю
          this.snackbarText = "Microsoft login configuration error.\n\n" + msg;
          this.snackbar = true;

          // 2) (опционально) сохраняем, чтобы после reload тоже можно было показать
          // но тут reload НЕ делаем, так что просто на будущее:
          setMsAuthError(this.snackbarText);

          this.msLoginInProgress = false;
          return;
        }

        // runtime-config для main.js
        sessionStorage.setItem(
          "msal_runtime_config",
          JSON.stringify({
            auth: {
              clientId: applicationId,
              authority,
              redirectUri: window.location.origin,
            },
            cache: {
              cacheLocation: "sessionStorage",
              storeAuthStateInCookie: true,
            },
          })
        );

        // команда main.js: стартануть loginRedirect
        sessionStorage.setItem("start_msal_login", "1");
        sessionStorage.setItem("msal_login_hint", email);

        // (опционально, но полезно)
        sessionStorage.setItem("ms_login_in_progress", "1");

        // один инстанс MSAL гарантируем reload-ом
        window.location.reload();
      } catch (error) {
        const msg =
          error?.response?.data ||
          error?.message ||
          "Failed to load Azure properties.";

        this.isErrorMicrosoftEmail = true;
        this.errorMicrosoftEmail = String(msg);

        // и snackbar тоже можно, чтобы было заметно пользователю
        this.snackbarText = String(msg);
        this.snackbar = true;

        // eslint-disable-next-line
        console.error("azure-properties error:", error);

        this.msLoginInProgress = false;
      }
    },

    closeModalLoginMs() {
      this.microsoftEmail = "";
      this.isErrorMicrosoftEmail = false;
      this.errorMicrosoftEmail = "";
      this.isShowModalLoginMs = false;

      this.msLoginInProgress = false;
      sessionStorage.removeItem("ms_login_in_progress");
      sessionStorage.removeItem("msal.interaction.status");
    },

    checkUserMSToken(token) {
      const payload = {
        access_token: token,
        state: true,
      };

      Axios.post(config.apiBaseUrl + "microsoft/token", qs.stringify(payload))
        .then((response) => {
          if (response.status === 200) {
            // применяем язык
            const lang = response.data.language.toLowerCase();
            Trans.changeLanguage(lang);
            localStorage.setItem("lang", lang);

            // 2логиним пользователя
            this.setUser(response.data, true);

            // очищаем runtime MSAL конфиг
            sessionStorage.removeItem("msal_runtime_config");
            sessionStorage.removeItem("ms_login_in_progress");
          }

          if (response.status === 202) {
            this.SET_USER_ORGANIZATIONS(response.data);
            router.push({ name: "selectStore" });
          }
        })
        .catch((error) => {
          const details = String(
            error?.response?.data || "Microsoft authorization failed."
          );

          this.accessError = true;
          this.accessErrorMessage =
            "An authorization error occurred while signing in with your Windows account.";

          this.snackbarText = details;
          this.snackbar = true;
        });
    },

    openMicrosoftLogin() {
      // reset flags of the previous attempt
      this.msAuthFailed = false;
      this.msLoginInProgress = false;

      // UI
      this.snackbar = false;
      this.snackbarText = "";

      // open modal
      this.isShowModalLoginMs = true;
    },

    setUser(userData, ms) {
      const session = saveAuthSession(userData, { microsoft: ms });
      Trans.changeLanguage(session.lang);

      if (ms) {
        this.isShowModalLoginMs = false;
      }

      this.SET_LOGIN_USER(userData);
      router.replace({
        name: session.passwordChangeRequired ? "changePassword" : "orders",
        params: { lang: session.lang || i18n.locale },
      });
    },

    handleForgotPasswordSubmit() {
      if (this.isForgotPassword && this.forgotPasswordUsername === "") {
        this.errorUsernameRequired = true;
        return;
      }
      if (this.isForgotPassword && this.forgotPasswordEmail === "") {
        this.errorForgotEmailRequired = true;
        return;
      }

      Axios.get(
        config.apiBaseUrl +
          `password-recovery?login=${this.forgotPasswordUsername}` +
          `&email=${this.forgotPasswordEmail}`
      )
        .then((response) => {
          /* eslint-disable */
          if (response.status === 200) {
            this.successAlert = true;
            this.successAlertMessage = this.$i18n.t("passwordSent");
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.accessError = true;
            this.accessErrorMessage = error.response.data;
          }
        });
      return;
    },

    handleLogInSubmit() {
      if (this.user.email === "") {
        this.errorEmailRequired = true;
        return;
      }

      if (this.user.password === "") {
        this.errorEmailRequired = false;
        this.errorEmailFormat = false;
        this.errorPasswordRequired = true;
        return;
      }

      if (this.user.password.length > this.passwordLength) {
        this.errorEmailRequired = false;
        this.errorEmailFormat = false;
        this.errorPasswordRequired = false;
        this.errorPasswordLength = true;
        return;
      }

      const payload = {
        username: this.user.email,
        password: this.user.password,
        remember: this.user.remember,
      };

      Axios.post(config.apiBaseUrl + "token", qs.stringify(payload))
        .then((response) => {
          /* eslint-disable */
          if (response.status === 200) {
            this.setUser(response.data);
          }
        })
        .catch((error) => {
          if (
            error.response.status === 400 &&
            error.response.data.indexOf("Invalid") !== -1
          ) {
            this.accessError = true;
            this.accessErrorMessage = this.$i18n.t("error_credential");
          } else if (
            error.response.status === 400 &&
            error.response.data.indexOf("access to work") !== -1
          ) {
            this.accessError = true;
            this.accessErrorMessage = this.$i18n.t(
              "error_credential_no_access"
            );
          } else {
            this.accessError = true;
            this.accessErrorMessage = error.response.data;
          }

          /* eslint-disable */
          console.log("error : ", {
            status: error.response.status,
            statusText: error.response.statusText,
            message: error.response.data,
          });
        });
    },

    handleSubmit(e) {
      e.preventDefault();

      this.errorEmailRequired = false;
      this.errorEmailFormat = false;
      this.errorPasswordRequired = false;
      this.errorPasswordLength = false;
      this.errorUsernameRequired = false;
      this.errorForgotEmailRequired = false;

      // this.errorCredential = false;
      // this.errorCredentialAccess = false;

      this.accessError = false;
      this.accessErrorMessage = "";

      this.successAlert = false;
      this.successAlertMessage = "";

      if (this.isForgotPassword) {
        this.handleForgotPasswordSubmit();
      } else {
        this.handleLogInSubmit();
      }
    },
    validEmail: function(email) {
      /* eslint-disable */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      return re.test(email);
    },

    async logoutMicrosoft() {
      try {
        // чистим наш токен приложения
        localStorage.removeItem("accessToken");
        localStorage.removeItem("loginMS");

        // чистим MSAL-флаги, чтобы не было interaction_in_progress
        sessionStorage.removeItem("msal.interaction.status");
        sessionStorage.removeItem("ms_login_in_progress");
        sessionStorage.removeItem("start_msal_login");
        sessionStorage.removeItem("msal_runtime_config");
        sessionStorage.removeItem("msal_login_hint");

        // закрываем snackbar
        this.snackbar = false;

        const account =
          this.$msalInstance.getActiveAccount?.() ||
          this.$msalInstance.getAllAccounts?.()?.[0];

        await this.$msalInstance.logoutRedirect({
          account,
          postLogoutRedirectUri: window.location.origin,
        });
      } catch (e) {
        this.snackbarText = String(e?.message || e);
        this.snackbar = true;
      }
    },
  },
};
</script>

<style>
.snackbar-content {
  padding: 0 !important;
}
.snackbar-content .v-snack__content {
  padding: 8px 12px !important;
}

.snackbar-root {
  padding: 10px 14px;
  max-width: 620px;
}

.snackbar-text {
  color: #ff5252 !important;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
}

.snackbar-actions {
  display: flex;
  justify-content: center;
  gap: 18px;
  margin-top: 12px;
}

.snackbar-btn {
  color: #1976d2 !important;
  font-weight: 600;
  letter-spacing: 0.6px;
}
</style>
